module.exports = __webpack_public_path__ + "static/media/AlertLargeFail.d6932291.svg";